module.exports = __webpack_public_path__ + "img/Ellipse15.2816b21c.png";